import { bicycleOutline, carOutline, chevronBackOutline, walkOutline } from 'ionicons/icons';
import { checkmarkDoneOutline } from 'ionicons/icons';
import { createOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { GestureController, ModalController } from '@ionic/angular/standalone';
import { combineLatest, firstValueFrom, interval, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from '../../../core/services/storage.service';
import { AppConfig } from '../../../config/routes.config';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../core/auth/auth.service';
import { TowerGroupDto, PaymentConfigurationDto, BookingRequest, PaymentAmountDto } from 'src/app/api/models';
import { UserBookingsApiService, UserTowerGroupsApiService, UserProfileApiService, UserBookingSharesApiService, UserSubscriptionsApiService } from 'src/app/api/services';
import { BookingStatus, StorageEnums, DateFormat, AlertType } from 'src/shared/models/enums';
import { CustomBookingDTO, CustomSubscriptionDTO, SubscriptionInfo } from 'src/shared/models/global.model';
import { PaymentObject } from 'src/shared/models/payment.model';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { DateHelperService } from 'src/shared/services/helpers/date-helper.service';
import { EventsService } from 'src/shared/services/helpers/events.service';
import { GeolocationService } from 'src/shared/services/helpers/geolocation.service';
import { HelperService } from 'src/shared/services/helpers/helper.service';
import { MyLogger } from 'src/shared/services/helpers/logging.service';
import { BookingHelperService } from 'src/shared/services/helpers/booking-helper.service';
import { SharedBookingAccessHelperService } from '../../shared-booking-access/services/shared-booking-access-helper.service';
import { PaymentsHelperService } from 'src/shared/services/helpers/payments-helper.service';
import { AlertService } from '@v-locker-app/v-locker-common';
import { ModalBaseComponent } from 'src/shared/components/modal-base/modal-base.component';
import { SharedBookingsAccessListPage } from '../../shared-booking-access/pages/shared-bookings-access-list/shared-bookings-access-list.page';
import { AddSharedBookingAccessPage } from '../../shared-booking-access/pages/add-shared-booking-access/add-shared-booking-access.page';
import { PaymentPage } from '../../payment/pages/payment/payment.page';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import moment from 'moment';
import { IonButton, IonIcon, IonSkeletonText, IonModal, IonDatetime } from "@ionic/angular/standalone";
import { AsyncPipe, DatePipe, DecimalPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { ContextHelpComponent } from 'src/shared/components/context-help/context-help.component';
import { IconComponent } from "../../../../shared/components/elements/icon/icon.component";
import { MinutesToHours } from "../../../../shared/pipes/minutes-to-hours.pipe";
import { CollapseDirective } from 'ngx-bootstrap/collapse';
import { DurationToNowPipe } from "../../../../shared/pipes/duration-to-now.pipe";
import { SliderButtonComponent } from "../../../../shared/components/elements/slider-button/slider-button.component";

@Component({
	selector: 'vl-booking-steps',
	templateUrl: './booking-steps.component.html',
	styleUrls: ['./booking-steps.component.scss'],
	imports: [IonDatetime, IonModal, IonSkeletonText, IonIcon, AsyncPipe, CollapseDirective, NgIf, NgFor, DatePipe, IonButton, NgIf, TranslatePipe, DecimalPipe, ContextHelpComponent, NgClass, IconComponent, MinutesToHours, DurationToNowPipe, SliderButtonComponent],
})
export class BookingStepsComponent extends MyLogger implements OnInit, OnChanges, OnDestroy, AfterViewInit {
	@ViewChild('swipeArea') swipeArea: ElementRef;
	@Input() booking: CustomBookingDTO;
	@Input() group: TowerGroupDto;
	@Input() currentStep: BookingStatus = BookingStatus.Create;
	@Input() startDateSub: string;
	@Input() fromBuySubscription: boolean = false;
	currentDate = moment(new Date()).format();

	private notifier: Subject<any> = new Subject<any>();
	paymentInfo: PaymentConfigurationDto = null;
	subscriptionInfo: SubscriptionInfo = null;
	stepsEnum = BookingStatus;
	distance = '';
	showSecondButton = true;
	firstButtonText;
	secondButtonText;
	isSubscribed = false;
	activeSubscription: CustomSubscriptionDTO;
	isCheckedSubscription = false;
	routes = AppConfig.routes;
	isShowShareButtons = false;
	isPublicView = true;
	isDescShown: boolean = false;
	disabledButton = false;
	currentLang: string;
	imageUlr: SafeResourceUrl;
	groups: TowerGroupDto[];
	routingIcons = [
		{
			icon: 'walk',
			type: 'foot'
		},
		{
			icon: 'bicycle',
			type: 'bike',
		},
		{
			icon: 'car',
			type: 'car'
		}
	];
	noAvailableSubs: boolean = false;
	isDatetimeModalOpen: boolean = false;
	yearsValue;
	towerStatus: string = 'CLOSED';
	towerStatusLoading: boolean = false;
	private costSubscription: Subscription;
	public currentCost: string;

	constructor(private modalController: ModalController,
				private bookingHelper: BookingHelperService,
				private sanitizer: DomSanitizer,
				private paymentsHelper: PaymentsHelperService,
				private bookingService: UserBookingsApiService,
				private groupsApiService: UserTowerGroupsApiService,
				private authHelpService: AuthService,
				private loader: CustomSpinnerService,
				private eventsService: EventsService,
				private router: Router,
				private translateService: TranslateService,
				private alertService: AlertService,
				private gestureCtrl: GestureController,
				private storage: StorageService,
				private userProfileService: UserProfileApiService,
				private subscriptionApiService: UserSubscriptionsApiService,
				private helpService: HelperService,
				private sharedAccessHelpService: SharedBookingAccessHelperService,
				private userSharingService: UserBookingSharesApiService,
				private shareService: UserBookingSharesApiService,
				private cd: ChangeDetectorRef,
				private authService: AuthService,
				private geolocationService: GeolocationService) {
    	addIcons({ chevronBackOutline, checkmarkDoneOutline, createOutline, walkOutline, bicycleOutline, carOutline });
		super('Booking Steps');
		this.authService.$userAuth
			.pipe(
				takeUntil(this.notifier)
			).subscribe(b => {
			this.isPublicView = !b;
			this.log('$auth: change isPublicView', this.isPublicView);
		});
	}

	async ngOnInit() {
		this.yearsValue = this.getFutureYearsList(10);
		this.handleLogic();
		this.eventsService.$updateGroupOnOpenedModalObs
			.pipe(
				takeUntil(this.notifier)
			)
			.subscribe(g => {
				this.group = ({...g, iconName: this.helpService.getStatusIconName(g)});
				this.getGroupImage(g);
				this.handleGroupFromInput();
			});

		await this.storage.removeItem(StorageEnums.BookingStep);
		this.currentLang = (await this.storage.getItem(StorageEnums.LANG))?.toUpperCase();
		if (this.group){
			this.getGroupImage(this.group);
		}
		if(this.booking && !this.booking?.shareId) this.startCostCalculation();
	}

	public ngAfterViewInit(): void {
		this.createGuesture();
		this.changeModalSize();
	}

	private changeModalSize() {
		// console.log('changeModalSize', this.booking.sharedWithMe, this.currentStep);
		let height;
		let minHeight;
		let bg;

		if (!this.booking) {
			height = '55%';
			minHeight = '385px';
		} else if (this.booking.sharedWithMe && this.currentStep === BookingStatus.OpenDoors && !this.booking.orderId) {
			height = '55%';
			minHeight = '385px';
			if (this.booking.isSharingActive) {
				bg = '#FCFEE9';
			}
		} else if (this.booking.sharedWithMe && this.currentStep === BookingStatus.OpenDoors && this.booking.orderId) {
			height = '65%';
			minHeight = '550px';
			if (this.booking.isSharingActive) {
				bg = '#FCFEE9';
			}
		} else if (this.currentStep === BookingStatus.OpenDoors) {
			// height = '60%';
			minHeight = '470px';
		} else {
			height = '55%';
			minHeight = '385px';
		}


		this.helpService.setCssVariable('sc-ion-modal-md-h', 'height', height);
		this.helpService.setCssVariable('sc-ion-modal-md-h', 'min-height', minHeight);
		this.helpService.setCssVariable('sc-ion-modal-ios-h', 'height', height);
		this.helpService.setCssVariable('sc-ion-modal-ios-h', 'min-height', minHeight);
		if (bg) {
			this.helpService.setCssVariable('sc-ion-modal-md-h', 'background', bg);
			this.helpService.setCssVariable('sc-ion-modal-ios-h', 'background', bg);
		}
	}

	public ngOnDestroy(): void {
		this.notifier.next('');
		this.notifier.complete();
	}

	ionViewWillEnter() {
		this.checkTowerStatus();
	}

	ionViewWillLeave() {
		this.notifier.next('');
		this.notifier.complete();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.group && changes.group.currentValue) {
		}
	}

	setOpen(isOpen: boolean) {
		if (!this.isPublicView) this.isDatetimeModalOpen = isOpen;
	}

	getFutureYearsList(numberOfYears: number) {
		return DateHelperService.futureYearsList(numberOfYears);
	}

	valueChanged(event) {
		this.startDateSub = event?.target?.value;
		this.convertSubscription();
	}

	convertSubscription() {
		const sub = this.group ? this.group.paymentConfigurations.find(p => p.type === 'SUBSCRIPTION') : null;
		this.subscriptionInfo = this.bookingHelper.convertSubscription({...sub, startDateSub: this.startDateSub || this.activeSubscription?.endDatePlus});
	}

	private handleLogic() {
		if (!this.group) {
			this.eventsService.$groupsObs
				.pipe(takeUntil(this.notifier))
				.subscribe(g => {
					this.groups = g;
					this.group = g.find(g => g.label === this.booking.towerGroupName);
					this.getGroupImage(g as TowerGroupDto);
					this.paymentInfo = this.group ? this.group.paymentConfigurations.find(p => p.type === 'PAY_PER_USE') : null;
					this.convertSubscription();
					this.getDistanceBetweenUserAndGroup();
				});
		} else {
			this.handleGroupFromInput();
		}

		if (this.currentStep === BookingStatus.CloseDoors) {
			this.openDoorModal(BookingStatus.DoorIsOpen);
		}
		this.showShareButtons();
	}

	hasDetailsForCurrentLang(): boolean {
		return this.group?.details?.length && this.group?.details?.some(detail => detail.locale === this.currentLang && detail.value);
	}

	private handleGroupFromInput() {
		this.paymentInfo = this.group.paymentConfigurations.find(p => p.type === 'PAY_PER_USE');
		const sub = this.group.paymentConfigurations?.find(p => p.type === 'SUBSCRIPTION');
		this.subscriptionInfo = this.bookingHelper.convertSubscription(sub);
		if (!this.isPublicView) {
			this.getActiveSubscriptionByGroupId();
		}
		this.getDistanceBetweenUserAndGroup();
	}

	getSubscriptionById(onSuccess?: any) {
		if (this.booking && this.booking.subscriptionId) {
			this.subscriptionApiService.getSubscription({
				id: this.booking.subscriptionId
			}).subscribe(r => {
				// this.log('getActiveSubscription', r);
				this.isCheckedSubscription = true;
				if (r !== null) {
					this.activeSubscription = r;
					this.isSubscribed = true;
					this.activeSubscription['capacityLeftStr'] = this.bookingHelper.calcTimeWithOffset(r.capacityLeft, true);
				}

				if (onSuccess) {
					onSuccess(r);
				}
			});
		}
	}

	changeStatus(g: TowerGroupDto) {
		switch (g && g.status === 'AVAILABLE') {
			case g.freeBoxesCount === 1:
				return 'booking-steps.facility.one-box';
			case g.freeBoxesCount === 2:
				return 'booking-steps.facility.two-boxes';
			case g.freeBoxesCount === 3:
				return 'booking-steps.facility.three-boxes';
			case g.freeBoxesCount > 3:
				return 'booking-steps.facility.more-than-three';
		}
	}


	getActiveSubscriptionByGroupId() {
		combineLatest([
			this.groupsApiService.getActiveSubscription({id: this.group.id}),
			this.bookingService.getUserActiveBookings1()
		]).subscribe(([r, activeBookings]) => {
			let activeBookingsTimeLeft = 0;
			const filteredBookings = r ? activeBookings.filter(b => b.subscriptionId === r.id): [];
			if(filteredBookings.length) activeBookingsTimeLeft = this.bookingHelper.calculateTimeList(activeBookings.filter(b => b.subscriptionId === r.id));
			this.log('getActiveSubscription', r);
			this.isCheckedSubscription = true;
			if (r !== null) {
				this.activeSubscription = r;
				this.isSubscribed = true;
				const capacityLeftWithBookings = r.capacityLeft - activeBookingsTimeLeft;
				const timeLeft = capacityLeftWithBookings > 0? this.bookingHelper.calcTimeWithOffset(capacityLeftWithBookings, true): 0 + ' ' + this.translateService.instant('time-periods.short-minutes');
				this.activeSubscription['capacityLeftWithBookings'] = capacityLeftWithBookings;
				this.activeSubscription['capacityLeftStr'] = timeLeft;
				this.activeSubscription['endDatePlus'] = moment(this.activeSubscription?.endDate).add(1, 'minute').format('yyyy-MM-DDTHH:mm:ss.SSSZ');
			}
			this.convertSubscription();
		});
	}


	close() {
		return this.modalController.dismiss(null, null, 'booking-details');
	}


	next() {
		this.currentStep++;
	}

	back() {
		if(this.fromBuySubscription) {
			return this.helpService.openFacilitiesList();
		}
		else if (this.currentStep === BookingStatus.Subscription && !this.fromBuySubscription) {
			return this.currentStep = BookingStatus.Create;
		}
		this.currentStep--;
		this.checkSecondButton();
		// if (this.currentStep === -1) {
		// 	this.log('back', this.currentStep);
		// 	this.close();
		// }
	}

	createBooking() {
		if (this.isPublicView) {
			this.currentStep = BookingStatus.Start;
		} else {
			this.currentStep = BookingStatus.Start;
			this.checkSecondButton();
			this.getButtonsInfoByStatus();
		}
	}

	startBooking(startUsingSubscription) {
		if (this.isPublicView) {
			return this.navigatueToSignIn();
		}
		this.authHelpService.checkVerification(
			() => {
				const body: BookingRequest = {
					startDate: DateHelperService.convertDate(new Date(), 'default', DateFormat.DefaultFormat, false),
					towerGroupId: this.group.id,
					subscription: startUsingSubscription
				};

				this.loader.show();
				this.bookingService.createBooking({
					body
				}).subscribe(r => {
						// this.analyticsService.logEvent(AnalyticsEvents.StartBooking, r);
						this.loader.hide();
						this.currentStep = BookingStatus.OpenDoors;
						this.booking = this.bookingHelper.convertBookingForSteps(r, this.group);
						this.booking.sharedBookingsAccessCount = 0;
						this.booking.activeSharedBookingsAccessCount = 0;
						this.getDistanceBetweenUserAndGroup();
						this.checkSecondButton();
						this.getButtonsInfoByStatus();
						this.startInterval();
						this.alertService.bookingCreated();
						this.eventsService.updateBookingTab();
						this.showShareButtons();
						this.changeModalSize();
						this.eventsService.refreshBookings();
						this.disabledButton = false;
						setTimeout(() => {		
							this.startCostCalculation();
						}, 0);
					},
					err => {
						this.loader.hide();
						this.alertService.noAvailableBoxes();
						console.error(err);
						this.disabledButton = false;
					});
			},
			() => {
				this.alertService.emailPhoneNotVerified(() => {
						this.close().then(() => {
							this.router.navigate([this.routes.settings.fullPath]);
						});
					},
					() => {

					});
			});
	}

	private async navigatueToSignIn() {
		await this.close();
		const returnUrl = this.routes.home.fullPath + '?groupId=' + this.group.id + '&step=' + this.currentStep;
		await this.storage.setItem(StorageEnums.RETURN_URL, returnUrl);
		return this.router.navigate([this.routes.auth.signIn.fullPath], {
			queryParams: {
				returnUrl,
			}
		});
	}

	getDistanceBetweenUserAndGroup() {
		if (this.group) {
			this.geolocationService.calculateDistance(this.group.geoLat, this.group.geoLng).subscribe(d => {
				this.distance = (d.dStr);
			});
		} else {
			this.distance = '-';
		}

	}

	showDoorsScreen(status: BookingStatus) {
		if(this.booking?.sharedWithMe) {
			this.booking.isSharingActive = this.sharedAccessHelpService.checkIfSharingIsActive(this.booking.startDate, this.booking.endDate, this.booking['sharedStatus']);
		}
		if (this.booking.sharedWithMe && !this.booking.isSharingActive) {
			return this.alertService.oneButtonsAlert(() => {
			}, AlertType.OpenDoorShareInactive);
		}
		this.disabledButton = true;
		this.loader.show(true).then(() => {
			this.geolocationService
				.calculateDistance(this.group.geoLat, this.group.geoLng)
				.subscribe(d => {
					console.log('geolocationService');
					// this.loader.hide().then(() => {
						if (d.d <= this.group.userDistance) {
							this.checkUncompletedDoorOpen(() => {								
								if (this.booking.sharedWithMe) {
									this.openDoorRequestForShare(status);
								} else {
									this.openDoorRequest(status);
								}
							}, true);
						} else {
							this.alertService.distanceAlert('distance-open', this.group.userDistance);
							this.disabledButton = false;
							this.loader.hide();
						}
					// });
				},err => {
					this.loader.hide();
					this.helpService.locationPermission();
					this.disabledButton = false;
				});
		});
	}

	openDoorRequest(status) {
		this.bookingService.openBox({ bookingId: this.booking.id })
			.subscribe(r => {
				// this.analyticsService.logEvent(AnalyticsEvents.OpenDoors, this.booking);
				this.disabledButton = false;
				this.bookingHelper.addBookingAtTheGate(this.booking.id);
				this.openDoorModal(status);
			}, err => {
				console.log(err);
				this.bookingHelper.OpenDoorAgain(() => {
						// try again
						this.showDoorsScreen(BookingStatus.DoorsIsOpening);
					}, () => {
						this.close();
						this.bookingHelper.openSupport(this.group);
						// contact support
					},
					() => {
						// cancel
					});
				this.disabledButton = false;
			});
	}

	openSupport() {
		this.bookingHelper.openSupport(this.group);
	}

	openDoorRequestForShare(status) {
		this.shareService.openBox1({ shareId: this.booking.shareId })
			.subscribe(r => {
				this.disabledButton = false;
				this.bookingHelper.addBookingAtTheGate(this.booking.id);
				this.openDoorModal(status);
			}, err => {
				this.bookingHelper.OpenDoorAgain(() => {
					// try again
					this.showDoorsScreen(BookingStatus.DoorsIsOpening);
				}, () => {
					this.close();
					this.bookingHelper.openSupport(this.group);
					// contact support
				},
				() => {
					// cancel
				});
				this.disabledButton = false;
			});
	}

	closeDoorRequest() {
		this.bookingService.closeBox({ bookingId: this.booking.id })
			.subscribe(r => {

			});
	}


	async openDoorModal(status: BookingStatus, towerStatus?: string, doorAction: boolean = false) {
		await this.loader.hide();
		const modal = await this.bookingHelper.openDoorModal(status, this.booking, this.group, towerStatus, doorAction);
		modal.onWillDismiss().then(v => {
			this.disabledButton = false;
			if (this.booking.sharedWithMe) {
				this.cd.detectChanges();
				setTimeout(() => {
					this.close().then(() => {
						this.cd.detectChanges();
						this.eventsService.refreshBookings();
					});
				}, 500);
			}
			if (v.data?.fromAbort) {
				this.currentStep = BookingStatus.OpenDoors;
			}
			// if(v.data?.towerStatus) {
				// this.towerStatus = v.data?.towerStatus;
			// }
			this.checkTowerStatus();
		});
		return await modal.present().then(() => {
			this.bookingHelper.handleOpenBooking(this.booking);
			this.currentStep = BookingStatus.Terminate;
		});
	}

	useSubscription() {
		this.doAction(this.stepsEnum.Start, true);
	}

	cancelBooking() {
		this.alertService.cancel(() => {
				this.checkBeforeTerminate(true);
			},
			() => {
				this.keepBooking();
			});
	}

	async checkShareAccess() {
		await this.shareAccess();
	}

	async shareAccess() {
		this.sharedAccessHelpService.setInfoData(this.booking);
		if (this.booking.sharedBookingsAccessCount < 1) {
			this.authHelpService.checkVerification(
				() => {
					this.close().then(async () => {
						const modal = await this.modalController.create({
							component: ModalBaseComponent,
							cssClass: "auto-height",
							componentProps: {
								rootPage: AddSharedBookingAccessPage,
								bookingId: this.booking.id
							},
							
						});
						modal.onWillDismiss().then(() => {});
						await modal.present().then(() => {});
					});
				},
				() => {
					this.alertService.emailPhoneNotVerified(() => {
							console.log('start closing');
							this.close().then(() => {
								console.log('close');
								this.router.navigate([this.routes.settings.fullPath]);
							});
						},
						() => {
						});
				});
		} else if (this.booking.sharedBookingsAccessCount >= 1) {
			await this.close();
			const modal = await this.modalController.create({
				component: ModalBaseComponent,
				cssClass: "auto-height",
				componentProps: {
					rootPage: SharedBookingsAccessListPage,
					bookingId: this.booking.id
				},
				
			});
			modal.onWillDismiss().then(v => {});
			await modal.present().then(() => {});
		}
	}

	checkStopAccess() {
		this.checkUncompletedDoorOpen(() => {
			this.stopAccess();
		});
	}

	stopAccess() {
		this.alertService.twoButtonsAlert(() => {
			this.revokeAccess();
		}, () => {

		}, AlertType.StopAccess);
	}

	revokeAccess() {
		this.userSharingService.deleteShare1({
			shareId: this.booking.shareId
		}).subscribe(() => {
			this.close();
			this.eventsService.refreshBookings();
		});
	}

	subscribe() {
		if (this.isPublicView) {
			this.currentStep = BookingStatus.Subscription;
		} else {
			this.authHelpService.checkVerification(
				() => {
					this.groupsApiService.getActiveSubscription({id: this.group.id}).subscribe((s)=> {
						if(s) this.activeSubscription = {...s, endDatePlus: moment(s?.endDate).add(1, 'minute').format('yyyy-MM-DDTHH:mm:ss.SSSZ')};
						this.convertSubscription();
						this.currentStep = BookingStatus.Subscription;
					});
				},
				() => {
					this.alertService.emailPhoneNotVerified(() => {
							this.close().then(() => {
								this.router.navigate([this.routes.settings.fullPath]);
							});
						},
						() => {

						});
				});
		}
	}

	checkAvailabilityForSubscription(proceed = false) {
		this.loader.show().then(() => {
			this.groupsApiService.canSubscribeToTowerGroup({
				id: this.group.id
			}).subscribe(r => {
				console.log('r', r.value);
				this.loader.hide();
				if (r.value.toLowerCase() === 'true') {
					this.noAvailableSubs = false;
					if(proceed) this.currentStep = BookingStatus.Subscription;
				} else {
					this.noAvailableSubs = true;
					if(proceed) this.alertService.noAvailableSubscriptions();
				}
			});
		});
	}

	subscribeNow() {
		if (this.isPublicView) {
			return this.navigatueToSignIn();
		} else {
			this.authHelpService.checkVerification(
				async () => {
					const subDate = new Date(this.startDateSub || this.activeSubscription?.endDatePlus || this.currentDate).toISOString();
					this.bookingHelper.towerReadyToAction(PaymentObject.Subscription, (valid ) =>{
						if(valid) this.payForSubscription();
					}, null, this.group.id, subDate);
				},
				() => {
					this.alertService.emailPhoneNotVerified(() => {
							this.close().then(() => {
								this.router.navigate([this.routes.settings.fullPath]);
							});
						},
						() => {

						});
				});
		}
	}

	payForSubscription() {
		this.preparePaymentDataForSubscription(this.subscriptionInfo);
		this.close().then(async () => {
			await this.storage.removeItem(StorageEnums.PurchaseRedirectUrl);
			await this.openPayments();
		});
	}

	async openPayments() {
		const modal = await this.modalController.create({
			component: PaymentPage,
			cssClass: 'auto-height payment-modal',
			componentProps: {
				fromBuySubscription: this.fromBuySubscription
			}
		});
		modal.onWillDismiss().then(v => {});
		await modal.present().then(() => {});
	}

	terminateBooking() {
		this.checkUncompletedDoorOpen(() => {
			this.currentStep = BookingStatus.Terminate;
			this.changeModalSize();
		});
	}

	keepBooking() {
		this.modalController.dismiss();
	}

	callTerminateBooking(e?: any) {
		const checkTermination = () => {
			this.loader.show().then(() => {
				this.checkBeforeTerminate();
			});
		};

		this.alertService.terminate(() => {
				if (this.booking.activeSharedBookingsAccessCount !== 0) {
					this.alertService.twoButtonsAlert(() => {
							checkTermination();
						}, () => {

						}, AlertType.TerminateWithShares,
						{ activeCount: this.booking.activeSharedBookingsAccessCount });
				} else {
					checkTermination();
				}
			},
			() => {
				this.keepBooking();
			});
	}

	/**
	 *  if Amount = null || 0 - user don't need to pay for the booking
	 *  if not null - user need to pay
	 */
	private checkBeforeTerminate(fromCancel = false) {
		this.bookingHelper.towerReadyToAction(PaymentObject.Booking, (valid) => {
			if(valid) {
				this.bookingService.getAmount({
					bookingId: this.booking.id,
					freeHours: 0
				}).subscribe(r => {
					this.log('getAmount', r);
					if (r.amount === null || Number(r.amount) === 0) {
						this.log('terminate');
						this.bookingService.terminateBooking({
							bookingId: Number(this.booking.id)
						}).subscribe(() => {
							this.eventsService.refreshBookings();
							this.bookingHelper.handleTerminateBooking(this.booking.id);
							this.close();
						}, async err => {
							await this.alertService.somethingWentWrong();
						});
					} else {
						this.userProfileService.getUserAccount()
							.subscribe(account => {
								this.preparePaymentData(r.amount.toFixed(2), r.currency,
									account.freeHours, r,
									() => {
										this.close().then(async () => {
											await this.storage.removeItem(StorageEnums.PurchaseRedirectUrl);
											await this.openPayments();
										}); 
									});
							});
					}
				}, async err => {
					await this.alertService.somethingWentWrong();
					await this.loader.hide();
				});
			}
		}, this.booking.id);
	}


	private preparePaymentData(amount, curency, freeHours, amountDto: PaymentAmountDto, onSuccess) {
		const bookingDuration = moment.duration(amountDto.bookingBreakdown.bookingDuration, 'minutes');
		const bookingDurationToPay = moment.duration(amountDto.bookingBreakdown.bookingDurationToPay, 'minutes');
		const coveredBySubscription = moment.duration(amountDto.bookingBreakdown.coveredBySubscription, 'minutes');
		this.log('this.booking.startDate', this.booking.startDate);
		// const calcTime = this.bookingHelper.calculateTime(this.booking.startDate, false);
		this.paymentsHelper.paymentData = {
			amountToPay: amount,
			bookingHours: Math.ceil(bookingDurationToPay.asHours()),
			type: PaymentObject.PayPerUse,
			// type: PaymentObject.Purchase,
			booking: this.booking,
			currency: curency,
			bookingId: this.booking.id,
			groupId: this.group.id,
			paymentMethods: this.group.paymentMethods,
			duration: this.bookingHelper.calcTime(bookingDuration, false, false),
			extraDuration: this.bookingHelper.calcTime(bookingDurationToPay, false, false),
			from: DateHelperService.convertDate(this.booking.startDate, 'default', DateFormat.ForDisplay),
			groupName: this.group.label,
			freeHours,
			recommendedFreeHours: amountDto.recommendedFreeHours,
			to: DateHelperService.convertDate(new Date(), 'default', DateFormat.ForDisplay),
			// purchase: {
			// 	productsCounts: 3,
			// 	purchaseDate: DateHelperService.convertDate(this.booking.startDate, 'default', DateFormat.ForDisplay),
			// 	id: 33
			// }
		};

		if (this.booking.subscriptionId && !this.isPublicView) {
			console.log('this.isPublicView', this.isPublicView);
			this.getSubscriptionById((subs) => {
				if (subs && subs.id === this.booking.subscriptionId) {
					// const durations = this.bookingHelper.calcTimeBySubscription(this.booking.startDate, this.activeSubscription.capacityLeft);
					this.paymentsHelper.paymentData = {
						...this.paymentsHelper.paymentData,
						...{
							subscriptionDuration: this.bookingHelper.calcTime(coveredBySubscription, false),
							extraDuration: this.bookingHelper.calcTime(moment.duration(amountDto.bookingBreakdown.bookingDurationToPay, 'minutes'), false),
						}
					};
					this.log(this.paymentsHelper.paymentData);
					onSuccess();
				} else {
					onSuccess();
				}
			});
		} else {
			onSuccess();
		}

	}

	private preparePaymentDataForSubscription(subscription: SubscriptionInfo) {
		this.paymentsHelper.paymentData = {
			amountToPay: subscription.rate,
			type: PaymentObject.Subscription,
			booking: null,
			currency: subscription.currencyCode,
			bookingId: null,
			groupId: this.group.id,
			paymentMethods: this.group.paymentMethods,
			duration: subscription.duration + ' ' + this.translateService.instant('time-periods.days'),
			from: subscription.start,
			groupName: this.group.label,
			to: subscription.end,
            subscriptionStartDate: new Date(this.startDateSub || this.activeSubscription?.endDatePlus || this.currentDate).toISOString()
		};

		this.log(this.paymentsHelper.paymentData);
	}

	private startCostCalculation() {
		if(!this.booking.shareId) {
			this.costSubscription = this.bookingHelper.calculateCost(this.booking, [this.group]).subscribe(cost => {
				this.currentCost = cost;
			});
		}
	}

	doAction(steps: BookingStatus, startUsingSubscription = false) {
		switch (steps) {
			case BookingStatus.Create:
				this.createBooking();
				break;
			case BookingStatus.Start:
				this.disabledButton = true;
				this.startBooking(startUsingSubscription);
				break;
			case BookingStatus.OpenDoors:
				this.disabledButton = true;
				this.showDoorsScreen(BookingStatus.DoorsIsOpening);
				break;
			case BookingStatus.DoorsIsOpening:
				this.disabledButton = true;
				break;
			case BookingStatus.CloseDoors:
				// this.closeDoors();
				break;
			case BookingStatus.DoorIsClosing:
				break;
			case BookingStatus.Terminate:
				this.terminateBooking();
				break;
		}

		this.changeModalSize();
	}


	getButtonsInfoByStatus() {
		switch (this.currentStep) {
			case BookingStatus.Create:
				this.firstButtonText = 'booking-steps.buttons.book';
				this.secondButtonText = 'booking-steps.buttons.subscribe';
				break;
			case BookingStatus.Start:
				this.firstButtonText = 'booking-steps.buttons.start';
				this.secondButtonText = 'booking-steps.buttons.remaining';
				break;
			case BookingStatus.OpenDoors:
				this.firstButtonText = 'booking-steps.buttons.open-doors';
				this.secondButtonText = this.booking.fiveMinLeft ? 'booking-steps.buttons.terminate-booking' : 'booking-steps.buttons.cancel-booking';
				break;
			case BookingStatus.DoorsIsOpening:
				break;
			case BookingStatus.CloseDoors:
				break;
			case BookingStatus.DoorIsClosing:
				break;
			case BookingStatus.Terminate:
				break;
			case BookingStatus.Subscription:
				break;
		}
	}

	async checkTowerStatus() {
		if(this.booking) {
			this.towerStatusLoading = true;
			const towerStatus = this.booking?.sharedWithMe ? await firstValueFrom(this.userSharingService.getUserOpenTowers1()): await firstValueFrom(this.bookingService.getUserOpenTowers());
			this.towerStatus = (towerStatus as any).find(v => ((v?.booking?.id || v.id) === this.booking.id)) ? 'OPEN': '';
			this.towerStatusLoading = false;
		}
	}

	private checkSecondButton() {
		// this.showSecondButton = this.currentStep !== this.stepsEnum.Start;
	}

	private startInterval() {
		if (this.booking) {
			interval(1000)
				.pipe(takeUntil(this.notifier))
				.subscribe(() => {
					this.bookingHelper.recalculateBooking(this.booking);
				});
		}
	}

	private createGuesture() {
		const conf: any = {
			el: this.swipeArea.nativeElement,
			direction: 'y',
			onMove: (detail) => {
				this.onMove(detail);
			}
		};
		const gesture = this.gestureCtrl.create(conf);

		gesture.enable();
	}

	public checkAcceptShare(id) {
		this.acceptShare(id);
	}

	private acceptShare(id) {
		this.loader.show().then(() => {
			this.userSharingService.acceptShare({
				shareId: id
			}).subscribe((r) => {
				this.booking.sharedStatus = r.status;
				this.eventsService.refreshBookings();
				// this.getShareById();
			}, error => {

			});
		});

	}

	private getShareById() {
		this.bookingService.getBookingShareById({
			id: this.booking.id,
			shareId: this.booking.shareId
		}).subscribe(r => {
			this.booking.sharedStatus = r.status;
			this.loader.hide();
		});
	}

	checkRejectShare(id) {
		this.rejectShare(id);
	}

	private rejectShare(id) {
		this.userSharingService.rejectShare({
			shareId: id
		}).subscribe((r) => {
			this.booking.sharedStatus = r.status;
			this.close();
			this.eventsService.refreshBookings();
		}, error => {

		});
	}

	private onMove(detail) {
		const y = detail.currentY - detail.startY;
		if (y >= 0.1) {
			this.close();
		}
	}

	public openAddressInBrowser() {
		const url = 'https://www.google.com/maps/search/' + this.group.address;
		window.open(url, '_system');
	}

	public async buildRoute(type: string) {
		await this.modalController.dismiss();
		this.geolocationService.setRoutingObs({
			geoLat: this.group.geoLat,
			geoLng: this.group.geoLng,
			type,
		});
		window.location.pathname.includes('/home') ? '': this.router.navigate(['/home']);
	}

	private showShareButtons() {
		this.isShowShareButtons = this.currentStep === this.stepsEnum.OpenDoors &&
			!this.booking?.sharedWithMe && this.booking.sharedBookingsAccessCount !== undefined;
	}

	public checkUncompletedDoorOpen(onNotFound, doorAction: boolean = false) {
		if (!this.booking.sharedWithMe) {
			this.bookingService.getUserOpenTowers()
				.subscribe(r => {
					const uncompletedDoorOpened = r.find(b => b.id === this.booking.id);
					if (uncompletedDoorOpened) {
						this.bookingService.getBookingTowerInfo({
							bookingId: uncompletedDoorOpened.id
						}).subscribe(t => {
							this.openDoorModal(BookingStatus.DoorIsOpen, t.status, doorAction);
						});
					} else {
						onNotFound();
					}
				});
		} else {
			this.shareService.getUserOpenTowers1()
				.subscribe((shares) => {
					const uncompletedDoorOpened = shares.find(sh => sh.booking.id === this.booking.id);
					if (uncompletedDoorOpened) {
						this.shareService.getTowerInfo({
							shareId: uncompletedDoorOpened.id
						}).subscribe(t => {
							this.openDoorModal(BookingStatus.DoorIsOpen, t.status, doorAction);
						});
					} else {
						onNotFound();
					}
				});
		}
	}

	getGroupImage(group: TowerGroupDto) {
		if (group.image) {
			(this.isPublicView ? this.groupsApiService.getTowerGroupImage1({id: group.id, size: 500}): this.groupsApiService.getTowerGroupImage({id: group.id, size: 500})).subscribe((res) => {
				this.imageUlr = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(res as unknown as Blob));
			});
		}
	}

	startBookingWithoutSub() {
		this.bookingHelper.startBookingConfirm(() => {
			this.doAction(this.stepsEnum.Start, false);
		});
	}

	async showBookingPincode(refresh: boolean = false) {
		const pin = refresh ? (await firstValueFrom(this.bookingService.updateBookingPin({bookingId: this.booking.id})))?.pin: this.booking.pin;
		this.booking.pin = pin;
		await this.bookingHelper.showPincode(pin, async () => {
			await this.showBookingPincode(true);
		});
	}
}


